import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonalCard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 18,
	viewBox: "0 0 20 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.25 7.5H16",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.25 10.5H16",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.63428 10.5C7.87692 10.5 8.88428 9.49264 8.88428 8.25C8.88428 7.00736 7.87692 6 6.63428 6C5.39164 6 4.38428 7.00736 4.38428 8.25C4.38428 9.49264 5.39164 10.5 6.63428 10.5Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.729 12.75C3.89546 12.106 4.27115 11.5355 4.79704 11.1283C5.32294 10.721 5.96923 10.5 6.63438 10.5C7.29952 10.5 7.94583 10.7209 8.47175 11.1282C8.99767 11.5354 9.3734 12.1058 9.5399 12.7498",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.25 1.5H1.75C1.33579 1.5 1 1.83579 1 2.25V15.75C1 16.1642 1.33579 16.5 1.75 16.5H18.25C18.6642 16.5 19 16.1642 19 15.75V2.25C19 1.83579 18.6642 1.5 18.25 1.5Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPersonalCard;
